import React from 'react';
import theme from './SupplierInput.module.scss';
import { t } from '@lingui/core/macro';
import Creatable from 'react-select/creatable';
import { classnames } from '@ygtechnologies/bygr-frontend-component-library';
import { uniq } from 'lodash-es';

interface SupplierInputProps {
    className?: string;
    placeholder?: string;
    onChange(newValue: string): void;
    value: string;
    existingValues: string[];
}

const SuggestInput = ({ className, placeholder, onChange, value, existingValues }: SupplierInputProps) => {
    const options = existingValues.map((x) => ({
        value: x,
        label: x,
    }));

    return (
        <Creatable
            classNamePrefix="r-s"
            className={classnames('react-select', className)}
            placeholder={placeholder}
            onChange={(x: any) => onChange(x?.label ?? null)}
            value={value ? { value: value, label: value } : null}
            isClearable
            options={options}
            noOptionsMessage={() => t`No suppliers`}
        />
    );
};

export default SuggestInput;
